export default __webpack_public_path__ + "static/media/img-0340-ukraine-full-face.f5ecef03.png";